import { useNavigate } from "react-router";
import { ReactComponent as EditIcon } from "../../assets/icons/tables/edit-icon.svg";
import { ReactComponent as TrashIcon } from "../../assets/icons/tables/trash-icon.svg";
import { useDropLocations } from "../../store/useDropLocations";
import { useAuth } from "../../store/useAuth";

export const DropLocationsTable = () => {
  /** Hooks */
  const { dropLocations, deleteDropLocation } = useDropLocations();
  const { user } = useAuth();
  const navigate = useNavigate();


  // Admins open a location for its parcel intake switch; changing or
  // deleting the location itself is Super Admin only (backend enforces both).
  const canManageLocations = [1, 7].includes(user?.user_role ?? -1);
  const canDeleteLocations = user?.user_role === 7;

  return (
    <div className="relative overflow-x-auto">
      <table className="w-full text-base font-normal font-satoshi text-left rtl:text-right text-dark">
        <thead className="font-medium bg-gray-50">
          <tr>
            <th scope="col" className="px-2 sm:px-6 py-1 sm:py-4">
              Name
            </th>
            <th scope="col" className="px-2 sm:px-6 py-1 sm:py-4">
              City
            </th>
            <th scope="col" className="px-2 sm:px-6 py-1 sm:py-4">
              Address
            </th>
            <th scope="col" className="px-2 sm:px-6 py-1 sm:py-4">
              Postal code
            </th>
            <th scope="col" className="px-2 sm:px-6 py-1 sm:py-4">
              Cost place
            </th>
            <th scope="col" className="px-2 sm:px-6 py-1 sm:py-4">
              Has Brinks
            </th>
            <th scope="col" className="px-2 sm:px-6 py-1 sm:py-4">
              Parcel intake
            </th>
            {canManageLocations ? (
              <th scope="col" className="px-2 sm:px-6 py-1 sm:py-4 text-right">
                Actions
              </th>
            ) : null}
          </tr>
        </thead>
        <tbody>
          {dropLocations?.map((dropLocation) => (
            <tr
              key={dropLocation?._id}
              className="bg-white hover:bg-gray-100 cursor-pointer transition ease-linear border-b"
            >
              <td
                onClick={() =>
                  canManageLocations
                    ? navigate(`/edit-drop-locations/${dropLocation?._id}`)
                    : undefined
                }
                className="px-2 sm:px-6 py-1 sm:py-4 whitespace-nowrap"
              >
                {dropLocation?.name}
              </td>
              <td
                onClick={() =>
                  canManageLocations
                    ? navigate(`/edit-drop-locations/${dropLocation?._id}`)
                    : undefined
                }
                className="px-2 sm:px-6 py-1 sm:py-4"
              >
                {dropLocation?.city}
              </td>
              <td
                onClick={() =>
                  canManageLocations
                    ? navigate(`/edit-drop-locations/${dropLocation?._id}`)
                    : undefined
                }
                className="px-2 sm:px-6 py-1 sm:py-4"
              >
                {dropLocation?.address}
              </td>
              <td
                onClick={() =>
                  canManageLocations
                    ? navigate(`/edit-drop-locations/${dropLocation?._id}`)
                    : undefined
                }
                className="px-2 sm:px-6 py-1 sm:py-4"
              >
                {dropLocation?.postalCode}
              </td>
              <td
                onClick={() =>
                  canManageLocations
                    ? navigate(`/edit-drop-locations/${dropLocation?._id}`)
                    : undefined
                }
                className="px-2 sm:px-6 py-1 sm:py-4"
              >
                {dropLocation?.cost_place}
              </td>
              <td
                onClick={() =>
                  user?.user_role === 1
                    ? navigate(`/edit-drop-locations/${dropLocation?._id}`)
                    : undefined
                }
                className="px-2 sm:px-6 py-1 sm:py-4"
              >
                {dropLocation?.hasBrinksMachines ? (
                  <span className="text-green-600 font-medium">Yes</span>
                ) : (
                  <span className="text-gray-400">No</span>
                )}
              </td>
              {/* Read-only here on purpose. Opening a store for production
                  intake is done from the Edit page, so a stray click in a
                  long list cannot do it. */}
              <td
                onClick={() =>
                  canManageLocations
                    ? navigate(`/edit-drop-locations/${dropLocation?._id}`)
                    : undefined
                }
                className="px-2 sm:px-6 py-1 sm:py-4 whitespace-nowrap"
              >
                {dropLocation?.parcelHandoffEnabled ? (
                  <span className="rounded-full bg-teal-50 px-2 py-0.5 text-xs font-medium text-teal-700">
                    Enabled
                  </span>
                ) : (
                  <span className="rounded-full bg-gray-100 px-2 py-0.5 text-xs font-medium text-gray-500">
                    Disabled
                  </span>
                )}
              </td>
              {canManageLocations ? (
                <td className="px-2 sm:px-6 py-1 sm:py-4 flex items-center justify-end cursor-pointer">
                  <EditIcon
                    onClick={() =>
                      navigate(`/edit-drop-locations/${dropLocation?._id}`)
                    }
                    className="mr-7"
                  />
                  {canDeleteLocations ? (
                    <TrashIcon
                      onClick={() => {
                        const confirmDelete = window.confirm(
                          "Are you sure you want to delete this Drop Location?"
                        );
                        if (confirmDelete) {
                          deleteDropLocation(dropLocation?._id as string);
                        }
                      }}
                    />
                  ) : null}
                </td>
              ) : null}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
